import filter from 'lodash/filter';
import { PerformanceAnalysisChartType } from '@/constants/performance';

export default {
  DBMS: {
    id: 'DBMS',
    chartType: PerformanceAnalysisChartType.MUTIL_OBJ,
    mainChart: {
      name: 'DB 응답 시간',
      filterObjFn: (objList) =>
        filter(objList, {
          elementType: 'DBMS',
        }),
      rscInfoList: [
        {
          rsctypeId: 'SYSSTAT',
          rscId: 'DB_RESPONSETIME',
          rscKey: '_',
        },
      ],
    },
  },
  E2E: {
    id: 'E2E',
    chartType: PerformanceAnalysisChartType.MUTIL_RSC_KEY,
    mainChart: {
      name: 'E2E 응답시간',
      filterObjFn: (objList) =>
        filter(objList, {
          elementType: 'E2E_SERVICE',
        }),
      rscInfoList: [
        {
          rsctypeId: 'SERVICESTATUS',
          rscId: 'RESPONSETIME_TOTAL',
        },
      ],
    },
  },
  NETDEVICE: {
    id: 'NETDEVICE',
    chartType: PerformanceAnalysisChartType.MUTIL_OBJ,
    mainChart: {
      name: '장비 트래픽',
      filterObjFn: (objList) =>
        filter(objList, {
          elementType: 'NETDEVICE',
        }),
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_TRAFFIC',
          rscId: 'TRAFFIC_BPS_IN',
          rscKey: '_',
        },
        {
          rsctypeId: 'DEVICE_TRAFFIC',
          rscId: 'TRAFFIC_BPS_OUT',
          rscKey: '_',
        },
      ],
    },
  },
  NETINTERFACE: {
    id: 'NETINTERFACE',
    chartType: PerformanceAnalysisChartType.MUTIL_OBJ,
    mainChart: {
      name: '인터페이스 트래픽 이용률',
      filterObjFn: (objList) =>
        filter(objList, {
          elementType: 'NETINTERFACE',
        }),
      rscInfoList: [
        {
          rsctypeId: 'TRAFFIC',
          rscId: 'TRAFFIC_USERATE_IN',
          rscKey: '_',
        },
        {
          rsctypeId: 'TRAFFIC',
          rscId: 'TRAFFIC_USERATE_OUT',
          rscKey: '_',
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/performance/node/analysis/service/perf-chart-type.js